<template>
    <div>


    </div>
</template>

<script>
    // import { BASE_URL } from "@/request/host";
    import { FORMAL_URL } from "@/utils/http.js";

    export default {
        data() {
            return {
            }
        },

        computed: {
            id() {
                return this.$route.query ? this.$route.query.id : ''
            }
        },
        methods: {
            browserRedirect() {
                var curURL = window.location.href;
                var sUserAgent = navigator.userAgent.toLowerCase();

                var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
                var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
                var bIsMidp = sUserAgent.match(/midp/i) == "midp";
                var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
                var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
                var bIsAndroid = sUserAgent.match(/android/i) == "android";
                var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
                var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";

                console.log(this.$route)

                if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
                    // 移动端浏览器 
                    document.write("phone");
                    //移动端浏览器
                    window.location.href = FORMAL_URL + "/mobile/#/login?id=" + this.id;
                    // window.location.href = "http://192.168.1.107:8080/#/login?id=" + this.id;

                    // if (curURL.indexOf("jd.com") != -1) {
                    //     window.location.href = "https://m.jd.com/";
                    // }
                } else {
                    // PC端浏览器
                    document.write("pc");
                    window.location.href = FORMAL_URL + "/web/#/login?id=" + this.id;
                    // window.location.href = "http://192.168.1.107:9292/web/#/login?id=" + this.id;

                    //  if (curURL.indexOf("jd.com") != -1) {
                    // window.location.href = "https://www.jd.com/";
                    //   }
                }
            }


        },
        created() {
            this.browserRedirect()
        },

        mounted: async function () {
        }
    };
</script>